
import React from 'react';
import { motion } from 'framer-motion';
import LazyImage from '@/components/ui/LazyImage';
import Section from './Section';
import { getStaticMediaUrl, STATIC_MEDIA_FILES } from '@/config/staticMedia';

interface AboutSectionProps {
  fadeInUp: any;
  staggerContainer: any;
}

const AboutSection: React.FC<AboutSectionProps> = ({
  fadeInUp,
  staggerContainer
}) => {
  return (
    <Section variants={staggerContainer} className="items-center relative overflow-hidden">
      {/* Gradiente de sobreposição elegante com vermelho/rosa/roxo */}
      <div className="absolute inset-0 bg-gradient-to-r from-luxury-purple/10 via-transparent to-luxury-red/10"></div>
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-black/20 to-transparent"></div>
      
      <div className="relative max-w-6xl mx-auto z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div variants={fadeInUp}>
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-8">
              Viva experiências que refletem o seu padrão e a sua ambição
              <br />
              <span className="bg-gradient-to-r from-luxury-red via-luxury-mediumPink to-luxury-purple bg-clip-text text-transparent">com sofisticação</span>
            </h2>
            <p className="text-xl text-white/80 mb-6 leading-relaxed">
              Jantares discretos. Destinos memoráveis. 
              <br />
              <span className="text-luxury-mediumPink/90">
                Encontros que não precisam de explicações, apenas de intenção.
              </span>
            </p>
            <p className="text-lg text-white/70 leading-relaxed">
              Na Interlaced, desejo e sofisticação caminham juntos com a discrição que o seu estilo de vida exige.
            </p>
          </motion.div>

          <motion.div variants={fadeInUp} className="lg:order-first">
            <div className="aspect-[4/3] rounded-2xl border border-white/20 overflow-hidden shadow-2xl shadow-luxury-purple/20 relative">
              <div className="absolute inset-0 bg-gradient-to-t from-luxury-red/20 to-transparent z-10"></div>
              <LazyImage
                src={getStaticMediaUrl(STATIC_MEDIA_FILES.DATE_2)}
                alt="Experiências Premium Interlaced"
                className="w-full h-full object-cover"
                fallbackClassName="w-full h-full"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </Section>
  );
};

export default AboutSection;
